export default "/images/GSA.jpg?d027bba9a891bc45e4b2e1074dcfee0d";